import dayjs from 'dayjs';
import apiClient from '../../../requests/api/apiClient';
import {
  buildCategories,
  buildCategoriesFromDates,
} from '../utils';

import { ChartFiltersWeather } from '../types';

const calculateEt0SeriesData = (
  data: Record<string, any>,
  days: string[],
  field: 'et0' | 'cumulativeET0',
) => days.map((day) => {
  const dayData = data[day];
  if (!dayData) return null;

  // x will be re-anchored to UTC noon at the chart layer (anchorPointsAtNoon).
  return {
    x: dayjs(day).valueOf(),
    y: dayData[field],
    custom: {
      date: dayjs(day).format('YYYY-MM-DD'),
    },
  };
}).filter(Boolean);

const prepareData = async (filters: ChartFiltersWeather, telemetryType?: string) => {
  const granularity = 'daily'; // getGranularity(filters.startDate, filters.endDate);

  const { data: { et0 } } = await apiClient.readings.getET0Data({
    farmId: filters.farmId,
    sectorId: filters.sectorId || '',
    startDate: filters.startDate,
    endDate: filters.endDate,
    wiseconnZoneId: filters.weatherZoneId || '',
    sn: filters.telemetryType === 'sn' ? filters.weatherZoneId : undefined,
    telemetryType: telemetryType || 'wiseconn',
    isWeatherStation: filters.isWeatherStation,
  });

  // build linear categories from filters
  const absoluteCategories = buildCategoriesFromDates(
    filters.startDate, filters.endDate,
  );

  const et0ChartData = calculateEt0SeriesData(et0, absoluteCategories, 'et0');
  const cumulativeEt0Data = calculateEt0SeriesData(et0, absoluteCategories, 'cumulativeET0');

  const chartCategories = buildCategories(
    granularity,
    absoluteCategories,
  );

  return {
    et0: et0ChartData,
    cumulativeEt0: cumulativeEt0Data,
    categories: chartCategories,
    absoluteCategories,
  };
};

export default prepareData;
